/**
 * @generated SignedSource<<e002bf0826b52911369bb26634b9d53a>>
 * @relayHash 3a73f34560a509f48c1ea80b52d70d6d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/539.0.0-2025-12-10T22:27:54.176Z/ReviewTextQuery

import { ConcreteRequest } from 'relay-runtime';
export type ReviewTextQuery$variables = {
  target: string;
  text: string;
};
export type ReviewTextQuery$data = {
  readonly viewer: {
    readonly translateText: {
      readonly text: string | null;
    } | null;
  };
};
export type ReviewTextQuery = {
  response: ReviewTextQuery$data;
  variables: ReviewTextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "target"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "text",
      "variableName": "text"
    }
  ],
  "concreteType": "TranslateText",
  "kind": "LinkedField",
  "name": "translateText",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "target",
          "variableName": "target"
        }
      ],
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReviewTextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReviewTextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/539.0.0-2025-12-10T22:27:54.176Z/ReviewTextQuery",
    "metadata": {},
    "name": "ReviewTextQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0cfc49befbb867ee393c9f7ea9e1a6db";

export default node;
